import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import Select from 'react-select';
import clsx from 'clsx';
import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import Routes from 'utils/routes.js.erb';
import { authHeaders } from 'actions';
import PropTypes from 'prop-types';

function SupervisorField({ cohortId, subgroupId, groupId }) {
  const { control, formState: { errors } } = useFormContext();
  const { data: supervisors, isLoading } = useQuery({
    queryKey: ['administration', 'organization', 'supervisors'],
    queryFn: () => axios.get(Routes.api_dashboard_administration_organizations_supervisors_path(
      {
        cohort_id: cohortId,
        subgroup_id: subgroupId,
        group_id: groupId,
      },
    ), { headers: authHeaders() }),
  });

  return (
    <>
      <span className='u-txt--label'>Supervisor</span><br />
      <span className='u-txt--label'>The person responsible for overseeing the entity</span>
      <br />
      <Controller
        name='supervisor_id'
        control={control}
        render={({ field: { onChange, value } }) => (
          <>
            <Select
              isLoading={isLoading}
              isClearable
              name='sp-group-select'
              className={clsx('o-select o-select--optgroup', { 'o-select--error': errors.supervisor_id })}
              value={isLoading || !value ? null : supervisors.data.find((supervisor) => supervisor.value === value)}
              onChange={(v) => {
                if (v) {
                  onChange(v.value);
                } else {
                  onChange(null);
                }
              }}
              options={isLoading ? [] : supervisors?.data || []}
            />
          </>
        )}
      />
      {errors.supervisor_id && (<p className='u-txt--error'>{errors.supervisor_id.message}</p>)}
    </>
  )
}

SupervisorField.propTypes = {
  cohortId: PropTypes.string,
  subgroupId: PropTypes.string,
  groupId: PropTypes.string,
};

export default SupervisorField;
